<template>
<div class="chapter">
<div class="inner_page">
<div class="part" id="part01">
<div class="partHead" id="parthead01">
<a id="page19">
</a><h2 class="partNumber" style="text-indent: 0%;"><a id="page19"><span class="bold"><span class="xrefInternal"></span></span></a><a href="#/003TOC#part_01">P<span class="smallCaps1">ART I</span></a></h2>
<h2 class="partTitle" style="text-indent: 0%;"><span class="bold"><em class="italic">A Special Bond</em></span></h2></div>
<div class="partBody">
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 006-part01.vue?6711b13e